import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import {CreateEditFormBase} from '../components/CreateEditFormBase'
import './CreateEdit.css';

import { withFirebase } from '../firebase';
import { AuthUserContext, withAuthorization } from '../session';


const Create = () => (
  <AuthUserContext.Consumer>
    {ctx => (
      <div>
        <img
          className="Create-logo"
          src={process.env.PUBLIC_URL + '/img/logo.png'}
          alt="logo"
        />
        <h1 className="Create-title">Create SONA <a href="http://sonad.io/instruction.html#create" target="_blank" rel="noopener noreferrer" className="Help">?</a></h1>

        <CreateForm user={ctx.authUser} admin={ctx.admin} />
      </div>
    )}
  </AuthUserContext.Consumer>
);



const CreateForm = compose(
  withRouter,
  withFirebase,
)(CreateEditFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Create);

export { CreateForm };
